<template>
	<v-container class="fill-height height-minus-navbar " fluid>
		<v-row class="align-self-start" v-if="projectsLoaded">
			<v-col cols=12>
				<h1 class="d-flex">
					<span v-if="!displayArchive">Проекты</span>
					<span v-else>Архив</span>
					<v-btn color="primary lighten-1" tile class="ml-auto" @click="displayArchive=!displayArchive; toggleArchivedProjectsView()">
						<v-icon left>mdi-archive</v-icon>
						Архив
					</v-btn>
				</h1>
			</v-col>
			<v-col cols="12" sm="8" md="6" lg="3" v-if="projectsLoaded && !displayArchive">
				<v-card flat height="100%" class="grey lighten-5">
					<ProjectForm />
				</v-card>
			</v-col>
			<v-col cols="12" sm="8" md="6" lg="3" v-for="(project, idx) in actualProjects" :key="idx">
				<ProjectForm :model="project" v-if="project.id == editingProjectId" />
				<v-card height="100%" v-if="project.id != editingProjectId">
					<v-card-title>
						{{ project.title }}
						<v-spacer></v-spacer>
						<v-menu bottom left close-on-click close-on-content-click>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on">
									<v-icon>mdi-dots-vertical</v-icon>
								</v-btn>
							</template>
							<v-list>
								<v-list-item @click="editingProjectId = project.id" v-if="!project.archived">
									<v-list-item-title>Редактировать</v-list-item-title>
								</v-list-item>
								<v-list-item @click="!project.archived ? archiveProject(project.id) : unArchiveProject(project.id)">
									<v-list-item-title v-text="!project.archived ? 'В архив' : 'Восстановить'"></v-list-item-title>
								</v-list-item>
								<v-list-item @click.stop="showConfirmDeleteDialog(idx, true)">
									<v-list-item-title>Удалить</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
						<v-dialog v-model="confirmDeleteDialog[idx]" max-width="290">
							<v-card>
								<v-card-title class="headline">Удалить проект?</v-card-title>
								<v-card-text>Вы действительно хотите удалить проект <b>«{{ project.title }}»</b>? Все тексты из этого проекта будут также удалены без возможности восстановления.</v-card-text>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn color="green darken-1" text @click="showConfirmDeleteDialog(idx, false)">
										Отмена
									</v-btn>
									<v-btn color="red darken-1" text @click="showConfirmDeleteDialog(idx, false); deleteProject(project.id)">
										Удалить
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>
					</v-card-title>
					<v-card-subtitle>
						Создан {{ project.created | localeDate }}
						<br>
						<span v-if="project.created != project.updated">Изменён {{ project.updated | localeDate }}</span>
						<br v-else>
					</v-card-subtitle>
					<v-card-text class="" style="overflow:hidden; height:150px">
						<p class="text--disabled" v-if="!project.description.length">Нет описания проекта</p>
						<p class="text--primary" v-else>{{ project.description }}</p>
					</v-card-text>
					<v-card-actions>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<div v-bind="attrs" v-on="on">
									<v-icon>mdi-file-document-outline</v-icon>
									<span class="subheading ml-1 mr-2 text--secondary">{{ project.get_docs_num }}</span>
								</div>
							</template>
							<span>Документов</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<div v-bind="attrs" v-on="on">
									<v-icon>mdi-message-text-outline</v-icon>
									<span class="subheading ml-1 mr-2 text--secondary">{{ project.get_words_num }}</span>
								</div>
							</template>
							<span>Слов</span>
						</v-tooltip>
						<v-spacer></v-spacer>
						<v-btn :to="`/project/${project.id}`" color="blue lighten-1" dark v-if="!project.archived">Перейти</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
		<v-row class="align-self-start" v-if="!projectsLoaded">
			<v-col cols="12">
				<v-skeleton-loader class="mt-4 mb-6" :loading="true" type="heading"></v-skeleton-loader>
			</v-col>
			<v-col cols="12" sm="8" md="6" lg="3" transition="scale-transition" v-for="i in [1,2,3,4]" :key="i">
				<v-skeleton-loader :loading="true" type="article, actions"></v-skeleton-loader>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import ProjectForm from './Form'

export default {
	name:"ProjectsList",
	components: { ProjectForm },
	data: () => ({
		projects: [],
		actualProjects: [],
		projectsLoaded:false,
		displayArchive:false,
		editingProjectId:null,
		pending:false,
	}),
	computed: {
		confirmDeleteDialog(){
			let arr = {}
			this.projects.forEach((p, idx) => arr[idx] = false)
			return arr
		}
	},
	created(){
		this.$eventBus.$on('user_log_out', () => this.$destroy())
		this.$eventBus.$on('project_created', data => this.createProject(data))
		this.$eventBus.$on('project_updated', data => {
			this.editProject(data)
			this.editingProjectId = null
		})
		this.getProjects()
	},
	beforeDestroy(){
		this.$eventBus.$off('project_created')
		this.$eventBus.$off('project_updated')
	},
	methods: {
		getProjects(){
			this.$api.get('projects/')
				.then(response => {
					this.projects = response.data
					if(!this.displayArchive){
						this.actualProjects = this.projects.filter(project => !project.archived)
					} else {
						this.actualProjects = this.projects.filter(project => project.archived)
					}
					this.projectsLoaded = true
				})
				.catch(error => console.log('Error getting projects list, ', error))
		},
		createProject(data){
			this.$api.post('projects/', data)
			.then(response =>{
				this.getProjects()
			})
			.catch(error => console.log('Error creating project, ', error))
		},
		editProject(data){
			this.$api.patch(`projects/${data.id}/`, data)
			.catch(error => console.log('Failed to update project, ', error))
		},
		deleteProject(projectId){
			this.$api.delete(`projects/${projectId}/`)
			.then(() => {
				let updatedProjectsList = this.actualProjects.filter(project => project.id != projectId)
				this.$set(this, 'actualProjects', updatedProjectsList)
				updatedProjectsList = this.projects.filter(project => project.id != projectId)
				this.$set(this, 'projects', updatedProjectsList)
			})
			.catch(error => console.log('Error deleting project, ', error))
		},
		archiveProject(projectId){
			this.$api.patch(`projects/${projectId}/`, { archived:true })
			.then(response => {
				this.getProjects()
			})
			.catch(error => console.log('Failed to archive project, ', error))
		},
		unArchiveProject(projectId){
			this.$api.patch(`projects/${projectId}/`, { archived:false })
			.then(response => {
				this.getProjects()
			})
			.catch(error => console.log('Failed to archive project, ', error))
		},
		toggleArchivedProjectsView(){
			this.actualProjects = this.displayArchive
				? this.projects.filter(project => project.archived)
				: this.projects.filter(project => !project.archived)
		},
		// this method is needed to handle project card menu
		// stayed open after deleting the project
		showConfirmDeleteDialog(idx, val){
			this.$set(this.confirmDeleteDialog, idx, val)
			this.$forceUpdate()
		}
	}
}
</script>